export const DEFAULT_BOARD_SIZE = 20
export const DEFAULT_SNAKE_SIZE = 5
export const MIN_BOARD_SIZE = 10
